import Config from "@app/constants/Config";
import localforage from "localforage";
import { authMiddleware, deepSearch } from "@app/utils/helper";
import { OutdatedError } from "@app/lib/errors/OutdatedError";
import { injectStandardPsaFieldset } from "@app/components/inspection-form/StandardPsaObserver.utils.jsx";

const store = localforage.createInstance({
	name: "inspectionConfig",
});

export async function loadInspectionConfig() {
	const response = await fetch(Config.API.FORM_CONFIG.LOAD, {
		credentials: "include",
	});
	await authMiddleware(response);
	return response.json();
}

export async function loadRiskAnalysis() {
	const response = await fetch(Config.API.FORM_CONFIG.LOAD_RISK_ANALYSIS, {
		credentials: "include",
	});
	await authMiddleware(response);
	return response.json();
}

export async function loadMeasuresOptions() {
	const response = await fetch(Config.API.FORM_CONFIG.LOAD_MEASURES_OPTIONS, {
		credentials: "include",
	});
	await authMiddleware(response);
	return response.json();
}

const setRiskAnalysisForm = (parentForm, riskAnalysisResult) => {
	const el = deepSearch(
		parentForm,
		"name",
		(key, name) => name === "physischegefaehrdungsanalyse_gefaehrdungen_gefaehrdungen",
	);
	el.formPage = riskAnalysisResult?.page?.forms?.steps?.[0];
};

function setStandardPsasFieldset(config) {
	injectStandardPsaFieldset(config?.forms?.steps);
}

export async function getInspectionConfig() {
	let config = await store.getItem("config");
	let cacheTime = await store.getItem("cacheTime");
	const valid = !!config && cacheTime && cacheTime + Config.API.FORM_CONFIG.CACHE > Date.now();

	if (!valid && navigator.onLine) {
		const [resIC, resRA] = await Promise.all([loadInspectionConfig(), loadRiskAnalysis()]);
		const { forms } = resIC.page;
		config = { forms };
		setRiskAnalysisForm(forms, resRA);
		setStandardPsasFieldset(config);
		await store.setItem("config", config);
		await store.setItem("cacheTime", Date.now());
	}
	if (!valid && !navigator.onLine) {
		throw new OutdatedError("inspection config");
	}
	if (!config) {
		throw new Response("", {
			status: 500,
			statusText: "Inspection config not available",
		});
	}
	config.forms.signsOverlayStep = config.forms.steps.find(({ identifier }) => identifier === "warnhinweise");
	config.forms.steps = config.forms.steps.filter(({ identifier }) => identifier !== "warnhinweise");
	return config;
}

export async function clearInspectionConfig() {
	return store.clear();
}
